// sessionStorage key for the last letter the user opened. Shared between LettersComponent (which
// reads/writes it) and LetterEffects (which clears it on a patient switch, since the switch can
// originate from a letter-detail route where LettersComponent is not mounted to clean up itself).
export const LAST_SELECTED_LETTER_ID_STORAGE_KEY = 'letters.lastSelectedLetterId';
